module.exports = __webpack_public_path__ + "assets/img/thumb_ch2-item-2.8e7b5ff5.jpg";